import React from "react";
import { FaSearch, FaTimes } from "react-icons/fa";
import { sanitizeInput } from "../../../utils/sanitization";

const SearchBar = ({ value, onChange, onClear }) => {
  const isTeamFilter = value.startsWith("team:");
  const teamId = isTeamFilter ? value.substring(5) : null;

  const handleClear = () => {
    onChange("");
  };

  const handleClearAll = () => {
    onClear();
  };

  // Same pattern as team name: no sanitization on keystroke (spaces work), sanitize on blur
  const handleInputChange = (e) => {
    onChange(e.target.value.substring(0, 100));
  };

  const handleBlur = (e) => {
    const sanitized = sanitizeInput(e.target.value).substring(0, 100);
    if (sanitized !== e.target.value) {
      onChange(sanitized);
    }
  };

  return (
    <div className="search-bar">
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <FaSearch className="h-4 w-4 text-brand-mist" />
        </div>
        <input
          type="text"
          value={value}
          onChange={handleInputChange}
          onBlur={handleBlur}
          placeholder="Search teams, bowlers..."
          maxLength={100}
          className="block w-full h-10 pl-10 pr-9 border border-brand-charcoal/20 rounded-lg leading-5 bg-white placeholder-brand-mist text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink sm:text-sm"
        />
        {value && (
          <button
            onClick={handleClear}
            className="absolute inset-y-0 right-0 pr-3 flex items-center text-brand-mist hover:text-brand-charcoal transition-colors"
            title="Clear search"
          >
            <FaTimes className="h-4 w-4" />
          </button>
        )}
      </div>

      {/* Show team filter status */}
      {isTeamFilter && (
        <div className="mt-2 flex items-center gap-2 text-sm">
          <span className="text-brand-charcoal font-medium">
            Showing team: {sanitizeInput(teamId)}
          </span>
          <button
            onClick={handleClearAll}
            className="text-brand-muted hover:text-brand-charcoal underline"
          >
            Show all teams
          </button>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
